const ROUTENAMES = {
  MAIN_PAGE_ROUTE: 'MainPageRoute',
  DASHBOARD_PAGE_ROUTE: 'DashboardPageRoute',
  MY_ACCOUNT_PAGE_ROUTE: 'MyAccountPageRoute',
  ORDER_DETAIL_PAGE_ROUTE: 'OrderDetailPageRoute',
  REQUEST_DETAIL_PAGE_ROUTE: 'RequestDetailPageRoute',
  ALL_CART_ORDERSREQUESTS_PAGE_ROUTE: 'AllCartOrdersRequestsPageRoute',
  SYSTEM_APPLICATIONS_PAGE_ROUTE: 'SystemApplicationsPageRoute',
  CATALOG_PAGE_ROUTE: 'CatalogPageRoute',
  CATALOG_PRODUCTS_PAGE_ROUTE: 'CatalogProductsPageRoute',
  CATALOG_SYSTEMS_PAGE_ROUTE: 'CatalogSystemsPageRoute',
  CART_OVERVIEW_PAGE_ROUTE: 'CartOverviewPageRoute',
  QR_SCAN_PAGE_ROUTE: 'QRScanPageRoute',
  PRODUCT_VIEW_PAGE_ROUTE: 'ProductViewRoute',
  SYSTEM_VIEW_PAGE_ROUTE: 'SystemViewRoute',
  CHECKOUT_MAIN_PAGE_ROUTE: 'CheckoutMainPageRoute',
  CHECKOUT_TYPE_PAGE_ROUTE: 'CheckoutTypePageRoute',
  CHECKOUT_DETAILS_PAGE_ROUTE: 'CheckoutDetailsPageRoute',
  CHECKOUT_SUMMARY_PAGE_ROUTE: 'CheckoutSummaryPageRoute',
  LOGIN_PAGE_ROUTE: 'LoginPageRoute',
  REGISTER_PAGE_ROUTE: 'RegisterPageRoute',
  PASSWORD_RESET_PAGE_ROUTE: 'PasswordResetPageRoute',
  PASSWORD_FORGOT_PAGE_ROUTE: 'PasswordForgotPageRoute',
  QCVMIXER_PAGE_ROUTE: 'QCVMixerPageRoute',
  ELASTICMIXER_PAGE_ROUTE: 'ElasticMixerPageRoute',
  TEST_GENERATOR_PAGE: 'TestGeneratorPage',
  ADMIN_PAGE_ROUTE: 'AdminPageRoute',
  ADMIN_DASHBOARD_PAGE_ROUTE: 'AdminDashboardPageRoute',
  ADMIN_USER_PAGE_ROUTE: 'AdminUserPageRoute',
  ADMIN_USER_DETAIL_PAGE_ROUTE: 'AdminUserDetailPageRoute',
  ADMIN_ORDER_PAGE_ROUTE: 'AdminOrderPageRoute',
  ADMIN_ORDER_DETAIL_PAGE_ROUTE: 'AdminOrderDetailPageRoute',
  ADMIN_REQUEST_PAGE_ROUTE: 'AdminRequestPageRoute',
  ADMIN_REQUEST_DETAIL_PAGE_ROUTE: 'AdminRequestDetailPageRoute',
  ADMIN_USER_REQUESTS_PAGE_ROUTE: 'AdminUserRequestsPageRoute',
  ADMIN_GENERAL_CONFIG_PAGE_ROUTE: 'AdminGeneralConfigPageRoute',
  ADMIN_MIXER_REQUEST_PAGE_ROUTE: 'AdminMixerRequestPageRoute',
  ADMIN_MIXER_REQUEST_DETAIL_PAGE_ROUTE: 'AdminMixerRequestDetailPageRoute',
};

export default ROUTENAMES;
